import React, { MutableRefObject } from "react";
import ct from "class-types.macro";
import Modal, { Header, Footer, Body } from "~/common/ModalReact";
import Button from "~/common/Buttons";
import Icon from "~/common/Icons/Standard";
import { AddToCartModal } from ".";

interface Props extends AddToCartModal<"warning"> {
  hasAcknowledgedProductWarning?: MutableRefObject<boolean>;
  setHasAcknowledgedProductWarning?: React.Dispatch<
    React.SetStateAction<boolean>
  >;
  warningContent: string;
}

const ProductWarningModal = ({
  isOpen,
  hasAcknowledgedProductWarning,
  setHasAcknowledgedProductWarning,
  warningContent,
  closeModal,
  submitModal,
}: Props) => {
  const handleAddToCart = async (event: React.SyntheticEvent) => {
    event.preventDefault();

    if (hasAcknowledgedProductWarning) {
      hasAcknowledgedProductWarning.current = true;
    }

    setHasAcknowledgedProductWarning?.(true);

    submitModal({ warning: true });
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      className={`${ct("w-11/12")}" modal--md`}
    >
      <Header closeModal={closeModal}>
        <Icon
          name="attention"
          className={ct("float-left", "h-6", "text-lg", "mr-1", "w-6")}
          style={{ fill: "#F8A12F" }}
        />
        <h3 className={ct("flex", "text-base", "m-0", "ml-3", "md:text-xl")}>
          Please Note!
        </h3>
      </Header>
      <Body className={ct("mt-5")}>
        <div
          className={`${ct("text-sm", "leading-5")}`}
          dangerouslySetInnerHTML={{
            __html: warningContent,
          }}
        />
      </Body>
      <Footer>
        <Button
          className={ct("ml-3")}
          color="blue"
          type="submit"
          onClick={handleAddToCart}
        >
          I Understand
        </Button>
      </Footer>
    </Modal>
  );
};

export default ProductWarningModal;
